/**
 * Shared feed adapter interface — RSS, Atom, JSON-feed, IPTV, radio-browser
 * all implement it.
 *
 * A Feed<T> is a source that can be fetched by URL (or without one, for
 * upstream APIs that take structured params) and yields parsed items.
 */
export interface Feed<T> {
  /** Human-readable name for logging / Slack notifications. */
  readonly name: string;
  /** Fetch and parse; caller supplies the network layer. */
  fetch(input: FeedInput): Promise<T[]>;
}

export type FeedInput =
  | { url: string; init?: RequestInit }
  | { url: string; init?: RequestInit; query?: Record<string, string | number> };

/**
 * Injected transport — a function that fetches a URL and returns text. Lets
 * us swap in axios in Cloud Functions and window.fetch in the browser
 * without either dragging the other in.
 */
export type FetchText = (url: string, init?: RequestInit) => Promise<string>;

export const defaultFetchText: FetchText = async (url, init) => {
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`fetch ${url} → ${res.status}`);
  return res.text();
};
